//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

export enum SortDir {
  ASC = 'asc',
  DESC = 'desc',
}
